import logo from '../logo.svg';
import { Typography, Paper, AppBar, Button, Box, Card, CardActions, CardContent, CardMedia, CssBaseline, Grid, Link, Toolbar, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (


    <div className="App">

      <ResponsiveAppBar />

      <main>

        <Container maxWidth="lg" className="subPageContainer">
          <Typography variant='h1' className='sectionTitle'>Immobilie schenken</Typography>

          <Box className='subpageBodyBox'>
            <Box className="serviceContentGrid">
              <Box className="serviceImgWrapper">
                <img src='Immobilien-Leistung.webp' className='serviceImg' />
              </Box>
              <Box>
              <Typography variant='body1' className='sectionText'>
                Wer seine Immobilie schon zu Lebzeiten auf die nächste Generation überträgt, kann erhebliche steuerliche Vorteile nutzen. Die sog. vorweggenommene Erbfolge wirft aber schwierige rechtliche und psychologische Fragen auf, insbesondere: Welches Kind übernimmt die Immobilie und muss vielleicht einen Ausgleich an die anderen Kinder zahlen? Wird das beschenkte Kind zusammen mit den weiteren Kindern das restliche Vermögen der Eltern erben? Was passiert, wenn die Kinder später das Eigentum an der Immobilie neu aufteilen wollen? Wer bezahlt die Pflegekosten, wenn ein Elternteil stark pflegebedürftig wird? Diese und weitere Fragen klären wir mit allen Familienmitgliedern in einer gemeinsamen Besprechung. Sodann entwerfen wir einen Vertrag, der den Interessen aller Beteiligten gerecht wird. Anschließend übernehmen wir die Abwicklung des Vertrages.
              </Typography>
              <Button className='btnSecondary'><HashLink smooth to="#">Immobilie schenken online abwickeln</HashLink></Button>
              </Box>
            </Box>

          </Box>

        </Container>

        <Box className="section bannergrey" id="kontakt">
          <Container maxWidth="lg" className="container" id="kontakt">
            <Box className="kontaktGrid">
              <Box className="kontaktLeftSide">
                <Typography variant='h2' className='sectionTitle white'>
                  Sie haben Fragen?  <br />
                  Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                </Typography>
                <Typography variant='body1' paragraph className='whiteText'>
                  Harbecke & Thelen Notare<br />
                  Holzgasse 29 - 33<br />
                  Siegburg 53721<br />
                </Typography>
              </Box>
              <Contactform />
            </Box>
          </Container>
        </Box>

      </main >
      <Footer />
    </div >
  );
}

export default Imprint;